import { render } from "./modal_telephonelie.vue?vue&type=template&id=4c816b01&scoped=true"
import script from "./modal_telephonelie.vue?vue&type=script&lang=js"
export * from "./modal_telephonelie.vue?vue&type=script&lang=js"

import "./modal_telephonelie.vue?vue&type=style&index=0&id=4c816b01&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c816b01"]])

export default __exports__